import { orbCore } from 'services/Orb/Service'
import { filterLists } from './Parser'

export const ActivityAdditionInformationService = {
  list: ({ type }) => orbCore.additionInformationDomain.list(type).then(filterLists)
}
